import React from 'react'
import Header from '../Header'
import Sidebar from '../Sidebar'

const AddProduct = () => {
  return (
    <>
    <Header/>
    <Sidebar/>
    <main id="main" className="main">
    <div className="container">
      <section className="section">
        <div className="row">
          <div className="col-lg-12">
          <div class="card">
           <div class="card-body">
          <h5 class="card-title"> ADD Product  </h5>
          <form>
  <div className="mb-3 row">
    <label htmlFor="productName" className="col-sm-2 col-form-label">
      Product Name
    </label>
    <div className="col-sm-10">
      <input type="text" className="form-control" id="productName" />
    </div>
  </div>
  <div className="mb-3 row">
    <label htmlFor="productDescription" className="col-sm-2 col-form-label">
      Product Description
    </label>
    <div className="col-sm-10">
      <textarea className="form-control" id="productDescription" rows="3"></textarea>
    </div>
  </div>
  <div className="mb-3 row">
    <label htmlFor="productPrice" className="col-sm-2 col-form-label">
      Product Price (in INR)
    </label>
    <div className="col-sm-10">
      <input type="number" className="form-control" id="productPrice" />
    </div>
  </div>
  <div className="mb-3 row">
    <label htmlFor="productCategory" className="col-sm-2 col-form-label">
      Product Category
    </label>
    <div className="col-sm-10">
      <select className="form-select" id="productCategory">
        <option value="electronics">Electronics</option>
        <option value="clothing">Clothing</option>
        <option value="books">Books</option>
        {/* Add more product categories */}
      </select>
    </div>
  </div>
  <div className="mb-3 row">
    <label htmlFor="productImage" className="col-sm-2 col-form-label">
      Product Image
    </label>
    <div className="col-sm-10">
      <input type="file" className="form-control" id="productImage" />
    </div>
  </div>
  <div className="text-center">
    <button type="submit" className="btn btn-primary">
      Add Product
    </button>
    <button type="reset" className="btn btn-secondary">
      Reset
    </button>
  </div>
</form>

  </div>
</div>

          </div>
        </div>
      </section>
      </div>
      </main>
    </>
  )
}

export default AddProduct